import { gql } from '@apollo/client';

export const ResumeDownloadQuery = gql`
  query ResumeDownload($language: String) {
    resumeDownload(language: $language)
      @rest(type: "Resume", path: "/?language={args.language}&preview=false", endpoint: "resume")
  }
`;
